export const getAllChilderId = (id, treeData) => {
    let chidlerId = [];
    const findChilder = (tree) => {
        if (id && tree && tree.length > 0) {
            tree.forEach((item) => {
                if (item.id === id) {
                    chidlerId = setDeepId(item.children);
                }
                if (item.children && item.children.length > 0) {
                    findChilder(item.children);
                }
            });
        }
    };
    findChilder(treeData);
    return chidlerId;
};
export const setDeepId = (tree) => {
    const treeId = [];
    if (tree && tree.length > 0) {
        const deepChilder = (treeData) => {
            treeData.forEach((item) => {
                if (item.id) {
                    treeId.push(Number(item.id));
                }
                if (item.children && item.children.length > 0) {
                    deepChilder(item.children);
                }
            });
        };
        deepChilder(tree);
    }
    return treeId;
};
